import type { AnyAction } from 'redux';
import type { OpaqueVideoData } from '@lumen5/luminary';

import { checkpointVideo, setVideoData } from 'js/src/data/video-data/video-data-actions';

export function video_data(state: OpaqueVideoData | null = null, action: AnyAction) {
    if (setVideoData.match(action) || checkpointVideo.match(action)) {
        return action.payload.video_data;
    }
    return state;
}
